<template>
  <div class="step-counter-list">
    <StepCounter
      v-for="step in steps"
      :key="step"
      class="step-counter-list__item"
      :text="getStepText(step)"
      :theme="getTheme(step)"
    />
  </div>
</template>

<script>
import StepCounter from '@/components/shared/steps-counters/StepCounter.vue';

export default {
  name: 'step-counter-list',
  components: {
    StepCounter,
  },
  props: {
    steps: {
      type: Number,
      required: false,
      default: 0,
    },
    currentStep: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  methods: {
    getTheme(step) {
      if (step < this.currentStep) {
        return 'passed'
      }

      if (step > this.currentStep) {
        return 'disabled'
      }

      return ''
    },
    getStepText(step) {
      return step < 10 ? `0${step}` : step.toString();
    },
  },
}
</script>

<style lang="scss" scoped>
.step-counter-list {
  display: flex;

  &__item {
    &:not(:last-child) {
      margin-right: rem(16);
    }
  }
}
</style>
